import { LOGIN_INFO_SHEET_CONTENT, LOGIN_INFO_SHEET_KEYS } from '@root/constants';
import { returnBottomSheetContent } from '@utils/utils';
import { Dispatch, SetStateAction } from 'react';
import { logCloseModal, logLogoutClicked } from './analyticsLogout';

interface InfoModalState {
  visible: boolean;
  data: ReturnType<typeof returnBottomSheetContent>;
  errorCode: string;
  fromLogout?: boolean;
}

type SetInfoModal = Dispatch<SetStateAction<InfoModalState>>;

interface BottomSheetHandlers {
  onOpenLogoutModal: () => void;
  onPressPrimaryButton: () => void;
  onPressSecondaryBottomSheet: () => void;
  onCloseModalHandler: (type: string) => void;
}

export default function bottomSheetHandlers(setInfoModal: SetInfoModal): BottomSheetHandlers {
  const onOpenLogoutModal = (): void => {
    logLogoutClicked();
    setInfoModal(prevState => ({
      ...prevState,
      visible: true,
      fromLogout: false,
      data: returnBottomSheetContent(
        LOGIN_INFO_SHEET_KEYS.LOGOUT,
        LOGIN_INFO_SHEET_CONTENT[LOGIN_INFO_SHEET_KEYS.LOGOUT],
      ),
      errorCode: LOGIN_INFO_SHEET_KEYS.LOGOUT,
    }));
  };

  const onPressPrimaryButton = (): void =>
    setInfoModal(prevState => ({ ...prevState, fromLogout: true, visible: false }));

  const onCloseModalHandler = (type: string): void => {
    setInfoModal(prevState => ({ ...prevState, fromLogout: false, visible: false }));
    logCloseModal(type);
  };

  const onPressSecondaryBottomSheet = (): void => {
    onCloseModalHandler('cancel');
  };

  return { onOpenLogoutModal, onPressPrimaryButton, onPressSecondaryBottomSheet, onCloseModalHandler };
}
